import WineCard from '../WineCard/WineCard';
import { Wine } from '../../Model/types';
import { useState } from 'react';
import './WineContainer.css';
import LoadingAnimation from '../LoadingAnimation/LoadingAnimation';

interface WineContainerProps {
  title: string;
  wines: Wine[];
  color: string;
  isOpen: boolean;
  onToggle: () => void;
}

const WineContainer = ({ title, wines, color, isOpen, onToggle }: WineContainerProps) => {
  return (
    <div className="wine-section" id={`section-${title}`}>
      <h2
        className="titulo-container"
        style={{ backgroundColor: color }}
        onClick={onToggle}
      >
        {title}
      </h2>

      {isOpen && (
        <div className="wine-container">
          {wines.length > 0 ? (
            wines.map((wine) => (
              <WineCard key={wine.id} wine={wine} />
            ))
          ) : (
            <LoadingAnimation fill={color} size={80} />
          )}
        </div>
      )}
    </div>
  );
};

export default WineContainer;